import { postMethodWithToken } from 'services/apiServices';
import url from 'services/urls.json';
import { ClearTokenRedirectLogin } from 'utils/general';

// Action Types
export const WEB_CHECKOUT = 'WEB_CHECKOUT';
export const WEB_CHECKOUT_SUCCESS = 'WEB_CHECKOUT_SUCCESS';
export const WEB_CHECKOUT_FAILURE = 'WEB_CHECKOUT_FAILURE';

// Action Creators
export const fetchWebCheckout = () => ({
  type: WEB_CHECKOUT,
});

export const fetchWebCheckoutSuccess = (data) => ({
  type: WEB_CHECKOUT_SUCCESS,
  payload: data,
});

export const fetchWebCheckoutFailure = (error) => ({
  type: WEB_CHECKOUT_FAILURE,
  payload: error,
});

// Thunk Function
export const webCheckoutCallAPI = (data, external = {}) => {
  return async (dispatch) => {
    dispatch(fetchWebCheckout(data, external));
    try {
      const response = await postMethodWithToken(url.webCheckout, data);
      if (response.status === 200 || response.status === 201) {
        dispatch(fetchWebCheckoutSuccess(response.data));

        if (external && external.redirect === true) {
          external.redirectNavigate(external.path);
        } else if (external && external.run === true) {
          external.handleFunction(response);
        } else if (external && external.step) {
          external.handleStep(external.step);
        }
      } else if (response.status === 401) {
        ClearTokenRedirectLogin(external?.navigate);
      } else {
        dispatch(fetchWebCheckoutFailure('Error'));
        if (external && external.toast) {
          external.handleToastError(response);
        }
      }
    } catch (error) {
      dispatch(fetchWebCheckoutFailure(error.message));
      if (external && external.toast) {
        external.handleToastError(error.response);
      }
    }
  };
};
